import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HelpPanelFeaturesItemProps } from '../types'
import { ApiError, RequestStatus } from 'features/common'

export const name = 'HelpPanel'

export interface HelpPanelState {
  open?: boolean
  features: HelpPanelFeaturesItemProps[]
  featuresStatus: RequestStatus
  featuresError?: ApiError
}

const initialState: HelpPanelState = {
  open: false,
  features: [],
  featuresStatus: RequestStatus.Idle
}

const reducers = {
  setHelpPanelOpen: (state: HelpPanelState, action: PayloadAction<boolean>) => {
    state.open = action.payload
  },
  setHelpPanelFeatures: (state: HelpPanelState, action: PayloadAction<Array<HelpPanelFeaturesItemProps>>) => {
    state.features = action.payload
  },
  setHelpPanelFeaturesStatus: (state: HelpPanelState, action: PayloadAction<RequestStatus>) => {
    state.featuresStatus = action.payload
  },
  setHelpPanelFeaturesError: (state: HelpPanelState, action: PayloadAction<ApiError>) => {
    state.featuresError = action.payload
  }
}

export const HelpPanelSlice = createSlice({
  name,
  initialState,
  reducers
})

export const { setHelpPanelOpen, setHelpPanelFeatures, setHelpPanelFeaturesStatus, setHelpPanelFeaturesError } =
  HelpPanelSlice.actions

export default HelpPanelSlice.reducer
